export const changePassword = (BeURL, showAlert, currentPassword, password, handleReset) => {
    fetch(`${BeURL}/update-password`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        credentials: "include",
        body: JSON.stringify({ currentPassword, password })
    })
        .then(res => res.json())
        .then(data => {
            showAlert(data.message)
            if (data.success) {
                handleReset()
                setTimeout(()=>{
                    window.location.href = "/"
                },[1000])
            }
        })
        .catch(err => {
            console.log("Error in updating password:", err)
            showAlert("Trouble in connetcing to the Server! Try after sometime.")
        })
}